import React, { useEffect, useState } from "react";
import { ric } from "@/lib/ric";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { AlertTriangle, Loader2 } from "lucide-react";

export default function RICDiscrepancies() {
  const { user } = useAuth();
  const { lang } = useLang();
  const t = (en, hi) => (lang === "en" ? en : hi);
  const isSup = ["ric_supervisor", "vendor_mg"].includes(user?.role);
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState("");

  const load = async () => setRows(await ric.discrepancies());
  useEffect(() => { load(); }, []);

  const close = async (d) => {
    const res = window.prompt(t("Resolution notes (RIC re-despatch / MG accepts short / return)?",
                                "समाधान (RIC पुनः प्रेषण / MG कम स्वीकार / वापसी)?"));
    if (!res) return;
    setBusy(d.id);
    try { await ric.closeDiscrepancy(d.id, { resolution: res }); await load(); }
    catch (e) { alert(e?.response?.data?.detail || e.message); }
    setBusy("");
  };

  return (
    <div data-testid="ric-discrepancies">
      <h1 className="text-2xl font-bold mb-4 flex items-center gap-2" style={{ color: "var(--brand-navy)", fontFamily: "'Fraunces', serif" }}>
        <AlertTriangle size={24} className="text-amber-600" /> {t("Discrepancies", "विसंगतियाँ")}
      </h1>
      <div className="space-y-2">
        {rows.map((d) => (
          <div key={d.id} className="hag-surface p-3" data-testid={`ric-disc-${d.id}`}>
            <div className="flex justify-between flex-wrap gap-2">
              <div>
                <div className="text-sm font-semibold" style={{ color: "var(--brand-navy)" }}>
                  {d.kind} · {d.kg_short} kg
                </div>
                <div className="text-xs text-[#7C8E9E] mt-0.5">
                  PO: {d.yarn_po_id?.slice(0, 8)} · {d.status === "Open"
                    ? <span className="status-chip pace-red">{t("Open", "खुला")}</span>
                    : <span className="status-chip pace-green">{t("Closed", "बंद")}</span>}
                </div>
                {d.note && <div className="text-xs mt-1">{d.note}</div>}
                {d.resolution && <div className="text-xs text-[#4A627A] mt-1">→ {d.resolution}</div>}
              </div>
              {d.status === "Open" && isSup && (
                <button data-testid={`ric-disc-close-${d.id}`} onClick={() => close(d)} disabled={busy === d.id}
                  className="h-9 px-3 rounded-md text-xs font-semibold text-white flex items-center gap-1"
                  style={{ background: "var(--brand-navy)" }}>
                  {busy === d.id ? <Loader2 size={12} className="animate-spin" /> : null}
                  {t("Close", "बंद करें")}
                </button>
              )}
            </div>
          </div>
        ))}
        {rows.length === 0 && <div className="text-sm text-[#7C8E9E]">{t("No discrepancies. Well done.", "कोई विसंगति नहीं।")}</div>}
      </div>
    </div>
  );
}
